import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { applyDocumentDirection } from './useTar'

// Import translation resources
import enTranslations from './locales/en.json'
import enCompanyTranslations from './locales/en-company.json'
import enSchoolTranslations from './locales/en-school.json'
import heTranslations from './locales/he.json'
import heCompanyTranslations from './locales/he-company.json'
import heSchoolTranslations from './locales/he-school.json'

// Initialize i18next
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
        company: enCompanyTranslations,
        school: enSchoolTranslations,
      },
      he: {
        translation: heTranslations,
        company: heCompanyTranslations,
        school: heSchoolTranslations,
      },
    },
    lng: 'en', // Default language
    fallbackLng: 'en', // Fallback language
    // debug: process.env['NODE_ENV'] === 'development',
    
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    
    // Namespace configuration
    defaultNS: 'translation',
    ns: ['translation', 'company', 'school'],
    
    // React i18next options
    react: {
      useSuspense: false, // Disable suspense for better error handling
    },
  })
  .then(() => {
    applyDocumentDirection(i18n.language)
  })

export default i18n
